import React, { Component } from "react";
import PropTypes from "prop-types";
import { displayParameters } from "../displays/allowance/display-parameters";
import { displaySubsidyEmployees } from "../displays/allowance/display-subsidy-employees";
import { translate as t } from "../../../infrastructure/translate/localization";
import { getAllowance } from "../../../infrastructure/allowance-config-repository";

export default class SubsidyPage extends Component {
  componentDidMount() {
    const { model, recurrentSubsidy, alertId } = this.props;
    const { mealDays, mealAmount, transportAmount, nurseryAmount } =
      getAllowance("generalParameters");
    displayParameters({ model, recurrentSubsidy });
    displaySubsidyEmployees({
      fromSubsidyPage: true,
      model,
      mealBenefit: model.mealBenefit,
      transportBenefit: model.transportBenefit,
      nurseryBenefit: model.nurseryBenefit,
      recurrentSubsidy,
      mealDays,
      mealAmount,
      transportAmount,
      nurseryAmount,
      alertId,
    });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    displayParameters({
      model: nextProps.model,
      recurrentSubsidy: nextProps.recurrentSubsidy,
    });
    displaySubsidyEmployees({
      fromSubsidyPage: true,
      model: nextProps.model,
      mealBenefit: nextProps.model.mealBenefit,
      transportBenefit: nextProps.model.transportBenefit,
      nurseryBenefit: nextProps.model.nurseryBenefit,
      recurrentSubsidy: nextProps.recurrentSubsidy,
    });
  }

  render() {
    const { recurrentSubsidy } = this.props;
    return (
      <main className="section">
        <div className="section-header">
          <h1 className="section-title">
            {t("subsidy-section.subsidy-delivery")}
          </h1>
        </div>
        <div className="section-container">
          <div className="section-header">
            {recurrentSubsidy ? (
              <p className="header-title">
                {t("subsidy-section.program-subsidy")}
              </p>
            ) : (
              <p className="header-title">
                {t("subsidy-section.detail-subsidy")}
              </p>
            )}
          </div>
          <div>
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>1</span>
                {t("subsidy-section.select-benefit")}
              </p>
            )}
            <div className="container-flex" id="parameters-section-container" />
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>2</span>
                {t("subsidy-section.employee")}
              </p>
            )}
            <div
              className="container-flex"
              id="subsidy-employees-table-container"
            />
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>3</span>
                {t("subsidy-section.accept-subsidy-config")}
              </p>
            )}
            <div
              className="container-flex"
              id="information-section-container"
            />
          </div>
        </div>
      </main>
    );
  }
}

SubsidyPage.defaultProps = { recurrentSubsidy: false, alertId: null };

SubsidyPage.propTypes = {
  model: PropTypes.object.isRequired,
  recurrentSubsidy: PropTypes.bool,
  alertId: PropTypes.string,
};
